@if (initialized && !busy) {
    <div class="card" style="height:80vh;">
        <iframe
                [srcdoc]="sanitizedHtml"
                sandbox="allow-scripts allow-same-origin"
                loading="lazy"
                height="100%"
                width="100%"
                style="border:0;"
        ></iframe>
    </div>
} @else {
    <p-skeleton width="100%" height="40vh"></p-skeleton>
}
